import { Injectable } from '@angular/core';
import { HttpRequest, HttpHandler, HttpEvent, HttpInterceptor, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { Router } from '@angular/router';
import { NotificationService } from './notification.service';

@Injectable()
export class ErrorInterceptor implements HttpInterceptor {
  constructor(private router: Router, private notify: NotificationService) {}

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request).pipe(
      catchError((error: HttpErrorResponse) => {

        // 1. Determine the context based on the URL
        const isAdminRequest = request.url.includes('/admin');
        const isPublicPortal = !isAdminRequest;

        // 2. Handle Database Timeouts (0 or 504)
        if (error.status === 0 || error.status === 504) {
          if (isAdminRequest) {
            // Admins just get a toast so they don't lose their form data
            this.notify.showError('Admin Panel: Database timeout. Please try again.');
          } else {
            // Public users get sent to a clean error page
            this.notify.showError('Connection Error: Server timeout. Please try again.');
            //this.router.navigate(['/error']);
          }
        }

        // 3. Handle Unauthorized (401)
        else if (error.status === 401) {
          // If admin session expires, send to admin login, otherwise public login
          const loginPath = isAdminRequest ? '/login' : '/login';
          this.router.navigate([loginPath]);
        }

        // 4. Handle Permissions (403)
        else if (error.status === 403) {
            this.notify.showError('Access Denied: You do not have permission for this resource.');

            if (isAdminRequest) {
                // Admins just get a toast so they don't lose their form data
                this.router.navigate(['/admin/403']);
            } else {
                // Public users get sent to a clean error page
                this.router.navigate(['/403']);
            }
        }

        // 5. General Server Failures (500)
        else if (error.status >= 500) {
          if (isAdminRequest) {
            this.notify.showError('System Error: Database procedure failed.');
          } else {
            this.notify.showError('System Error: Please try again.');
            this.router.navigate(['/500']);
          }
        }

        return throwError(error);
      })
    );
  }
}
